
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"52","height":"52","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.804 9c2.31-4 8.083-4 10.392 0l12.125 21c2.309 4-.578 9-5.197 9H13.876c-4.62 0-7.506-5-5.197-9L20.804 9z","fill":"#FFD580"}}),_c('path',{attrs:{"d":"M27.285 17.16l-.339 9.808H24.45l-.36-9.808h3.196zM25.76 31.72c-.536 0-.98-.155-1.333-.467a1.596 1.596 0 01-.508-1.198c0-.474.17-.866.508-1.178.352-.325.797-.487 1.333-.487.522 0 .952.162 1.291.487.339.312.508.704.508 1.178s-.17.873-.508 1.198c-.339.311-.769.467-1.29.467z","fill":"#CC8900"}})])
          )
        }
      }
    